import React, { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import ReactPlayer from 'react-player';
import { useLocation } from 'react-router-dom';
import { MdClose } from "react-icons/md";
import { trackEvent } from '../../utils/gaTracking';
import { useSelector } from 'react-redux';

function VideoPlayer({ setShow, playlist }) {
    const [currentTrackIndex, setCurrentTrackIndex] = useState(0);
    const authState = useSelector((state) => state.authUser);
    const user_id = authState?.profile?.user_id;
    const user_email = authState?.profile?.email;

    return (
        <div>
            <div className="d-flex justify-content-end">
                <Button className="btn btn-sm btn-primary float-right" onClick={() => { setShow(false) }}><MdClose /></Button>
            </div>
            <Row>
                <Col md={9}>
                    <div>
                        <ReactPlayer width='100%' url={playlist[currentTrackIndex]?.media_url} controls muted={true} playing={true}
                            onPlay={() =>
                                trackEvent("hrd_knowledge_clips_new_video_played", "HRD Video Player", playlist[currentTrackIndex]?.title || "Unknown Video", 1, user_id, user_email)
                            }
                            onPause={() =>
                                trackEvent("hrd_knowledge_clips_new_video_paused", "HRD Video Player", playlist[currentTrackIndex]?.title || "Unknown Video", 1, user_id, user_email)
                            }
                            onEnded={() =>
                                trackEvent("hrd_knowledge_clips_new_video_completed", "HRD Video Player", playlist[currentTrackIndex]?.title || "Unknown Video", 1, user_id, user_email)
                            }
                        />
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                        </div>

                    </div>
                </Col>
                <Col md={3}>
                        <div className='d-flex justify-content-between mt-2' style={{ backgroundColor: '#000', color: '#fff', borderRadius: '5px 5px 0px 0px'}}>
                            <div className='p-3 text-center'>Queue</div>
                        </div>
                        <ul className="playlist" style={{overflow:'scroll', height:'300px'}}>
                            {playlist.map((track, index) => (
                                <li
                                    key={index}
                                    onClick={() => {
                                        setCurrentTrackIndex(index);
                                        trackEvent("hrd_knowledge_clips_new_video_opened", "HRD Video Player", playlist[index]?.title || "Unknown Video", 1, user_id, user_email);
                                    }
                                    }
                                    className={currentTrackIndex === index ? 'active' : ''}
                                >
                                    {track.title}
                                </li>
                            ))}
                        </ul>
                </Col>
            </Row>
        </div>
    )
}

export default VideoPlayer
